import React, { useEffect, useState } from 'react'
import purchasedSpare from "../assets/purchasedSpare/purchasedSpare.json"

const ClientSellingRecord = () => {
    const [data, setData] = useState({})

    useEffect(() => {
        setData(modifyData(purchasedSpare))
    }, [])

    const modifyData = (arr) => {
        let data = {}
        arr.forEach(item => {
            if (!data[item.company_id]) {
                data[item.company_id] = []
            }
            data[item.company_id].push(item)

        })
        return data
    }
    return (
        <div className='card-spare-contain'>
            <h2>Purchased Spare List of Companies in First Quarter [01-Apr-2024 - 31-Jun-2024]</h2>
            {Object.keys(data).map((key, i) => {
                return (
                    <div className='card-spare' key={i}>
                        <table id="customers">
                            <tr>
                                <th>{data[key][0].Company}</th>
                                <th>Qty</th>
                            </tr>
                        {data[key].map((item2, p) => (
                            <tr className='' key={p}>
                                <td>{item2.Item}</td>
                                <td>{item2.Quantity} {item2.Unit}</td>
                            </tr>
                        ))}
                        </table>
                    </div>
                )
            })}
        </div>
    )
}

export default ClientSellingRecord
